import * as React from "react"
import classNames from "classnames"
import { headline } from "./Headline.module.css"

export const Headline = ({ children, className }) => {
  return <h1 className={classNames(headline, className)}>{children}</h1>
}
